// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".nav-searchbar[data-v-50024288]{background-color:var(--color-neutral-3);border-color:var(--color-neutral-4);caret-color:var(--color-primary-5);transition:border-color .2s ease-in-out}.nav-searchbar[data-v-50024288]:focus-within{border-color:var(--color-primary-6);color:var(--color-neutral-10)}.nav-searchbar__input[data-v-50024288]:focus{outline:none}.nav-searchbar__input[data-v-50024288]::-webkit-search-cancel-button{display:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
